/**
 * @file: WeWork.shared.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
export type WeWorkResp = {
  errCode: number;
  errStr: string;
  type: string;
};

export class WeWorkError extends Error {
  code: number;

  constructor(resp: WeWorkResp) {
    super(resp.errStr || resp.errCode.toString());
    this.name = 'WeWorkError';
    this.code = resp.errCode;
  }
}
